// extracted by mini-css-extract-plugin
module.exports = {"styledInput":"IMDVlIDt","textAlignRight":"zdlbvbfx"};